export enum OperationExecutorType {
  ARTIFACT = 'artifact',
  FIELD_VALUE = 'field_value',
  REPORT = 'report',
  REPORTS_V2 = 'reports_v2',
  DAMS_IMPORT = 'dams_import'
}
